import * as React from "react";
import { auth } from "../config/firebase";
import { onAuthStateChanged } from "firebase/auth";

interface ImpersonationState {
  isSupport: boolean;
  isImpersonating: boolean;
  impersonatedBy: string | null;
}

export function useImpersonation(): ImpersonationState {
  const [state, setState] = React.useState<ImpersonationState>({
    isSupport: false,
    isImpersonating: false,
    impersonatedBy: null,
  });

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setState({
          isSupport: false,
          isImpersonating: false,
          impersonatedBy: null,
        });
        return;
      }

      const tokenResult = await user.getIdTokenResult();
      const claims = tokenResult.claims;

      setState({
        isSupport: claims.role === "support",
        isImpersonating: !!claims.impersonatedBy,
        impersonatedBy: (claims.impersonatedBy as string) || null,
      });
    });

    return () => unsubscribe();
  }, []);

  return state;
}
